export default __webpack_public_path__ + "static/media/hht1_ep7_minisitcom_03.0e8f83c4.png";